// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2vvH_","balanceDisclaimer":"posDashboard_balanceDisclaimer__1KlMe"};